import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { countriesExtendedAll } from "@studyportals/static-domain-data/countries/countries-extended";
import { ICountry } from "@studyportals/static-domain-data/src/countries/i-country";
import { countryGetIsoCodePath } from "@studyportals/static-domain-data/countries/country-get-iso-path";
import { countryGetIdFromIsoCode } from "@studyportals/static-domain-data/countries/country-get-id-from-iso-code";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";

const isCountryRecord = (value: ICountry): boolean => {
	if (!value || typeof value !== "object") {
		return false;
	}

	return typeof value.iso === "string" && typeof value.name === "string";
};

export class CountryFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.COUNTRY;
	public isMultiSelect = true;
	private static instance: CountryFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] =[];
	private isoToIdMap: Map<string, string> = new Map();

	// TODO original processor had some extra logic for sorting countries by name, should we add it here?
	public static getInstance(): CountryFilterMapper {
		if (!CountryFilterMapper.instance) {
			CountryFilterMapper.instance = new CountryFilterMapper();
		}
		return CountryFilterMapper.instance;
	}

	private constructor() {
		super();

		for (const entry of countriesExtendedAll) {
			if (!isCountryRecord(entry)) {
				continue;
			}

			const country = entry;
			const virtualPath = countryGetIsoCodePath(country.iso);
			if(virtualPath){
				this.values.push({
					id: country.iso,
					virtualPath,
					name: country.name
				});
				const countryId = countryGetIdFromIsoCode(country.iso);
				if (countryId) {
					this.isoToIdMap.set(country.iso, countryId);
				}
			}
		}
	}

	public getCountryIdFromIsoCode(isoCode: string): string | undefined {
		return this.isoToIdMap.get(isoCode);
	}

	public getIsoByCountryId(countryId: string): string | undefined {
		return Array.from(this.isoToIdMap.entries()).find(([, id]) => id === countryId)?.[0];
	}
}
